import { CustomModal, NakedTable, ProtectedLink } from "components";
import { useCallback, useMemo, useState } from "react";
import { useStudentPmrQuery } from "./queries";
import { FiSearch } from "react-icons/fi";

const lessonRecordColumns = [
  {
    header: "Date",
    accessor: (row) => <div>{row?.lessonDetail?.date}</div>,
    noWrap: true,
  },
  {
    header: "Lesson",
    accessor: (row) =>
      row?.lessonDetail?.lesson?.name ? (
        <div>{row?.lessonDetail?.lesson?.name}</div>
      ) : (
        <span className="text-muted">Not Filled In</span>
      ),
  },
  {
    header: "Teacher",
    accessor: (row) => (
      <div>
        {row?.lessonDetail?.teacher?.fullName || (
          <span className="text-muted">None</span>
        )}
      </div>
    ),
  },
  {
    header: "Teachers Remark",
    accessor: (row) =>
      row?.lessonDetail?.teachersRemark ? (
        <span>{row?.lessonDetail?.teachersRemark}</span>
      ) : (
        <span className="text-muted">Not filled in</span>
      ),
  },
];

const studentPmrsColumns = [
  {
    header: "Date",
    accessor: (row) => <div>{row?.date}</div>,
    noWrap: true,
  },
  {
    header: "Subject",
    accessor: (row) => <div>{row?.studentCourse?.course?.name}</div>,
  },
  {
    header: "Teacher",
    accessor: (row) => (
      <div>
        {row?.createdBy?.fullName || <span className="text-muted">None</span>}
      </div>
    ),
  },
  {
    header: "Teachers Remark",
    accessor: (row) =>
      row?.remarks ? (
        <span>{row?.remarks}</span>
      ) : (
        <span className="text-muted">Not filled in</span>
      ),
  },
  {
    header: "Notes",
    alignment: "center",
    accessor: (row) => (
      <ProtectedLink
        href={row?.notesPath}
        target="_blank"
        label={<FiSearch className="text-warning" />}
        rel="noreferrer"
      />
    ),
  },
];

const useStudentProfileModal = (studentsData, courseId) => {
  const [toggled, setToggled] = useState(false);
  const [studentIdToView, setStudentIdToView] = useState(0);

  const open = useCallback(() => setToggled(true), []);
  const close = useCallback(() => setToggled(false), []);
  const viewStudent = useCallback((studentIdToView) => {
    open();
    setStudentIdToView(studentIdToView);
  }, []);

  const studentToShow = useMemo(() => {
    return studentsData?.find((student) => student.id === studentIdToView);
  }, [studentIdToView, studentsData]);

  const { data: studentPmrs } = useStudentPmrQuery(studentToShow?.id);

  const filteredLessons = useMemo(() => {
    return studentToShow?.lessonRecords
      .filter(
        (lessonRecord) =>
          lessonRecord.lessonCompleted &&
          lessonRecord.lessonDetail.courseId === courseId,
      )
      .sort((lessonRecord1, lessonRecord2) => {
        return lessonRecord1?.lessonDetail?.date >
          lessonRecord2.lessonDetail.date
          ? -1
          : lessonRecord1?.lessonDetail?.date < lessonRecord2.lessonDetail.date
            ? 1
            : 0;
      });
  }, [courseId, studentToShow?.lessonRecords]);

  const ModalBody = () => (
    <CustomModal
      compact={true}
      show={toggled}
      title={!studentPmrs || !studentToShow ? "Loading..." : "Student Profile"}
      zIndex={30}
      hideModal={close}
    >
      <div className="row">
        <small className="col">
          <div className="d-flex" style={{ columnGap: 10 }}>
            <dt className="text-info">First Name: </dt>
            <dd className="text-secondary">{studentToShow?.firstName}</dd>
          </div>
          <div className="d-flex" style={{ columnGap: 10 }}>
            <dt className="text-info">Last Name: </dt>
            <dd className="text-secondary">{studentToShow?.lastName}</dd>
          </div>
          <div className="d-flex" style={{ columnGap: 10 }}>
            <dt className="text-info">Age: </dt>
            <dd className="text-secondary">{studentToShow?.age || "None"}</dd>
          </div>
        </small>

        <small className="col">
          <div className="d-flex" style={{ columnGap: 10 }}>
            <dt className="text-info">Primary Language: </dt>
            <dd className="text-secondary">
              {studentToShow?.primaryLanguage || "None"}
            </dd>
          </div>
          <div className="d-flex" style={{ columnGap: 10 }}>
            <dt className="text-info">Public Exams: </dt>
            <dd className="text-secondary">
              {studentToShow?.publicExams || "None"}
            </dd>
          </div>
          <div className="d-flex" style={{ columnGap: 10 }}>
            <dt className="text-info">Current School: </dt>
            <dd className="text-secondary">
              {studentToShow?.currentSchool || "None"}
            </dd>
          </div>
        </small>
        <small className="col-12">
          <div className="d-flex flex-column" style={{ columnGap: 10 }}>
            <dt className="text-info">Additional Info: </dt>
            <dd className="text-secondary mt-1 bg-dark p-2 rounded text-white">
              {studentToShow?.additionalInfo || "None"}
            </dd>
          </div>
        </small>
      </div>
      <NakedTable
        className="mb-2"
        title="Parent Meetings"
        data={studentPmrs}
        columns={studentPmrsColumns}
        maxHeight={250}
        textWrap={true}
      />
      <NakedTable
        title="Lesson Records"
        data={filteredLessons}
        columns={lessonRecordColumns}
        maxHeight={400}
        textWrap={true}
      />
    </CustomModal>
  );

  return {
    StudentProfileModal: ModalBody,
    controls: { open, close },
    viewStudent,
  };
};

export default useStudentProfileModal;
